import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";
import NavBar from "./components/navBar";
import LoginForm from "./components/users/loginForm";
import Logout from "./components/users/logout";
import Users from "./components/users/users";
import UserForm from "./components/users/userForm";
import ProfileForm from "./components/users/profileForm";
import Leagues from "./components/leagues/leagues";
import LeagueForm from "./components/leagues/leagueForm";
import Seasons from "./components/seasons/seasons";
import SeasonForm from "./components/seasons/seasonForm";
import MatchDays from "./components/matchDays/matchDays";
import MatchDayForm from "./components/matchDays/matchDayForm";
import Teams from "./components/teams/teams";
import TeamForm from "./components/teams/teamForm";
import Matches from "./components/matches/matches";
import MatchForm from "./components/matches/matchForm";
import MatchBetForm from "./components/matchBets/matchBetForm";
import HallOfFame from "./components/hallOfFame/hallOfFame";
import Stats from "./components/stats/stats";
import Ranking from "./components/ranking/ranking";
import ProtectedRoute from "./components/common/protectedRoute";
import auth from "./services/authService";
import "./App.css";

class App extends Component {
  state = {};

  componentDidMount() {
    const user = auth.getCurrentUser();
    this.setState({ user });
  }

  render() {
    const { user } = this.state;
    const year = new Date().getFullYear();

    return (
      <React.Fragment>
        <NavBar user={user} />
        <main className="container">
          <Switch>
            <Route path="/login" component={LoginForm} />
            <Route path="/logout" component={Logout} />
            <ProtectedRoute path="/profile" component={ProfileForm} />
            <ProtectedRoute path="/users/:id" component={UserForm} />
            <ProtectedRoute path="/hall-of-fame" component={HallOfFame} />
            <ProtectedRoute path="/stats" component={Stats} />
            <ProtectedRoute path="/match-bets" component={MatchBetForm} />
            <ProtectedRoute path="/ranking" component={Ranking} />
            <ProtectedRoute path="/users" component={Users} />
            <ProtectedRoute path="/leagues/:id" component={LeagueForm} />
            <ProtectedRoute path="/leagues" component={Leagues} />
            <ProtectedRoute path="/seasons/:id" component={SeasonForm} />
            <ProtectedRoute path="/seasons" component={Seasons} />
            <ProtectedRoute path="/matchdays/:id" component={MatchDayForm} />
            <ProtectedRoute path="/matchdays" component={MatchDays} />
            <ProtectedRoute path="/teams/:id" component={TeamForm} />
            <ProtectedRoute path="/teams" component={Teams} />
            <ProtectedRoute path="/matches/:id" component={MatchForm} />
            <ProtectedRoute path="/matches" component={Matches} />
          </Switch>
          <center>
            <div className="copy-separator">
              <span>
                &copy;{year} - <a href="http://www.anacondev.com">Anacondev</a>
              </span>
            </div>
          </center>
        </main>
      </React.Fragment>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js